import React, { useEffect, useState } from "react";
import { Button, Dropdown, Form, InputGroup } from "react-bootstrap";
import {
  EditIcon,
  FilterCollapseIcon,
  FilterIcon,
  FilterTwoIcon,
  RefreshIcon,
  TrashIcon,
  ViewIcon,
} from "../Icons";
import TargetCreationModal from "./CreateTargetModal";
import useDebounce, {
  useLocalStorage,
  useQueryParams,
} from "../../utils/hooks";
import { Popover } from "react-tiny-popover";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import Select from "react-select";

import {
  customerFullName,
  customerTypeOptions,
  defaultSelectValue,
  fetchActionsUtil,
  formatDateTime,
  paginationOptions,
  reactSelectTheme,
} from "../../utils/helpers";
import { endOfDay, format, parse, startOfDay } from "date-fns";
import TransactionsTable from "../utils/TransactionsTable";
import CustomerSelector from "../utils/CustomerSelector";
import RsDateRangePicker from "../utils/RsDateRangePicker";
import TableComponent from "../TableComponent";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import { useAuth } from "../../hooks/useAuth";
import { useMutation, useQuery } from "react-query";
import queryString from "query-string";
import currency from "currency.js";
import NoTableItem from "../utils/NoTableItem";
import { isEmpty } from "lodash";
import ReactPaginate from "react-paginate";
import TargetPerformanceModal from "./TargetPerformanceModal";
import { message } from "antd";
import { toast } from "react-toastify";

export default function TargetPage() {
  const [show, setShow] = useState(false);
  const [showFilter, setShowFilter] = useLocalStorage("showTarget", true);
  const { backendUrl } = useAuth();
  const [isUpdate, setIsUpdate] = useState(false);
  const [target, setTarget] = useState({});

  const initialFilterParams = {
    customerName: "",
    customerId: "",
    startDate: "",
    endDate: "",
    enableDateRange: true,
    group: "",
    type: "",
    q: "",
  };
  const [showItemsPopover, setShowItemsPopover] = useState(false);
  const [view, setView] = useState(false);
  const [customerGroup, setCustomerGroup] = useState([]);
  const [customerType, setCustomerType] = useState([]);
  const [showDetails, setShowDetails] = useState({
    title: "",
    id: "",
  });
  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });
  const { data, refetch, isFetching, isSuccess } = useQuery(
    ["GET_EB_COMPANY", queryParams],
    () =>
      fetchActionsUtil(
        `${backendUrl}/api/company/target-dashboard?${queryString.stringify(
          queryParams
        )}`
      ),

    {
      onSuccess: (data) => {
        const groups = data?.group?.map(({ Group }) => ({
          value: Group,
          label: Group,
        }));
        const types = [
          ...customerTypeOptions,
          ...data?.type?.map(({ TransType }) => ({
            value: TransType,
            label: TransType,
          })),
        ];

        setCustomerGroup(groups);

        setCustomerType(types);
      },
      enabled: true,
      keepPreviousData: true,
    }
  );

  const deleteMutation = useMutation(
    (id) =>
      fetchActionsUtil(`${backendUrl}/api/company/target/${id}`, "DELETE"),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        refetch();
      },
      onError: ({ message }) => {
        toast.error(`unable to perform action ${message}`);
      },
    }
  );

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams((q) => ({
      ...q,
      ...debouncedFilterParams,
    }));
  }, [debouncedFilterParams, setQueryParams]);

  const handleFilterParamsChange = (e) => {
    setFilterParams({
      ...filterParams,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const handleSearchQueryChange = (e) => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const filterByDateRange = (date) => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      enableDateRange: true,
    });
  };

  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };

  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
  };

  const handleSelectedCustomer = (customer) => {
    setFilterParams({
      ...filterParams,
      customerId: customer.Cust_ID,
      customerName: customerFullName(customer),
    });
    setShowItemsPopover(false);
  };

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          <th />

          {/* <th>Target Type</th> */}
          {/* <th>Target Type</th> */}
          <th>Target Group</th>
          <th>Period</th>
          <th>Target Amount</th>
          <th>Amount Realized</th>
          <th>Progress</th>
          <th>Start Date</th>
          <th>End Date</th>
        </tr>
      </thead>
    );
  };

  const tableData = (el, index) => {
    const startDate = formatDateTime(el?.startDate);
    const endDate = formatDateTime(el?.endDate);
    return (
      <>
        <td>
          <Dropdown>
            <Dropdown.Toggle
              variant=""
              className="bg-white border-0"
              bsPrefix="print more"
            >
              <DotsVerticalIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu
              popperConfig={{
                strategy: "fixed",
              }}
              renderOnMount
              className="dropdown-with-icons"
            >
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setShowDetails({
                    id: el.id,
                    title:
                      el?.targetType === "specific-customer"
                        ? customerFullName(el.customers[0])
                        : el?.targetGroup,
                  });
                  setView(true);
                }}
              >
                {/* <Form.Switch checked={Boolean(el?.completed)} /> Mark as */}
                <ViewIcon /> View
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setTarget(el);
                  setIsUpdate(true);
                  setShow(true);
                }}
              >
                <EditIcon /> Update
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => deleteMutation.mutate(el.id)}
              >
                <TrashIcon /> Delete
              </Dropdown.Item>
              {/* <Dropdown.Item
                  as="button"
                  onClick={() => {
                    setIsSpecificCompany(true);
                    setCompanyId(el?.CompanyID);
                    setCompanyName(el?.CompanyName);
                    setShecduleMaintenance(true);
                  }}
                >
                  <ClockIcon /> Schedule Maintenance{" "}
                </Dropdown.Item> */}
              {/* <Dropdown.Item as="button">
                  <CloseIcon />
                  Cancel Schedule
                </Dropdown.Item> */}
            </Dropdown.Menu>{" "}
          </Dropdown>
        </td>

        <td>
          {el?.targetType === "specific-customer"
            ? customerFullName(el.customers[0])
            : el?.targetGroup}
        </td>
        {/* <td>{el?.companyTarget}</td> */}
        <td>{el?.period}</td>
        {/* <td>{el?.targetType}</td> */}

        <td>
          {currency(el?.targetAmount).format({
            symbol: "",
            separator: ",",
          })}
        </td>
        <td>
          {currency(el?.total).format({
            symbol: "",
            separator: ",",
          })}
        </td>
        <td>{el?.progress}%</td>
        <td>
          {startDate.date}
          {startDate.time}
        </td>
        <td>
          {endDate.date}
          {endDate.time}
        </td>
      </>
    );
  };

  return (
    <main className="cash-book ">
      <div className="content border rounded-4">
        <div className="content-main">
          <div className={` mt-2 filter-area ${showFilter ? "open" : "close"}`}>
            <div className="filter-header">
              <h2>
                <FilterIcon color="#94A3B8" /> Filter
              </h2>

              <Button
                variant="white"
                onClick={() => setShowFilter(!showFilter)}
              >
                <FilterCollapseIcon />
              </Button>
            </div>
            <div className="filter-body ">
              <Form>
                <div className="body">
                  {" "}
                  <Form.Group className="mb-2-5">
                    <Form.Label>Search</Form.Label>{" "}
                    <Form.Control
                      name="q"
                      value={filterParams?.q}
                      placeholder="Enter Text"
                      onChange={(e) => handleFilterParamsChange(e)}
                    />{" "}
                  </Form.Group>
                  <Form.Group className="mb-2-5">
                    <Form.Label>Customer ID</Form.Label>
                    <InputGroup>
                      <Form.Control
                        name="customerId"
                        placeholder="Enter Customer ID"
                        value={filterParams?.customerId}
                        onChange={(e) => handleFilterParamsChange(e)}
                      />
                      <Popover
                        isOpen={showItemsPopover}
                        onClickOutside={() => setShowItemsPopover(false)}
                        content={() => (
                          <CustomerSelector
                            handleSelectedCustomer={handleSelectedCustomer}
                            setShowCustomerSelector={setShowItemsPopover}
                          />
                        )}
                        position="bottom"
                      >
                        <InputGroup.Text
                          onClick={() => setShowItemsPopover(!showItemsPopover)}
                        >
                          <MagnifyIcon />
                        </InputGroup.Text>
                      </Popover>
                    </InputGroup>
                  </Form.Group>
                  <Form.Group className="mb-2-5">
                    <Form.Label>Customer Name</Form.Label>
                    <Form.Control
                      name="customerName"
                      value={filterParams?.customerName}
                      placeholder="Enter Customer Name"
                      onChange={(e) => handleFilterParamsChange(e)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-2-5">
                    <Form.Label>Customer Group</Form.Label>
                    <Select
                      classNamePrefix="form-select"
                      menuPosition="fixed"
                      menuPlacement="auto"
                      placeholder="All"
                      theme={reactSelectTheme}
                      isSearchable={false}
                      key={data?.invoiceCat}
                      options={customerGroup || []}
                      onChange={(selected) => {
                        setFilterParams({
                          ...filterParams,
                          group: selected.value,
                        });
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-2-5">
                    <Form.Label>Customer Type</Form.Label>
                    <Select
                      classNamePrefix="form-select"
                      menuPosition="fixed"
                      menuPlacement="auto"
                      placeholder="All"
                      theme={reactSelectTheme}
                      isSearchable={false}
                      key={"KEY_HERE"}
                      options={customerType || []}
                      onChange={(selected) => {
                        setFilterParams({
                          ...filterParams,
                          type: selected.value,
                        });
                      }}
                    />
                  </Form.Group>
                  <hr className="mt-3 mb-4" />
                  <div className="mb-2-5">
                    <Form.Check
                      inline
                      label="Enable Date Range"
                      name="enableDateRange"
                      type={"checkbox"}
                      id={`enableDateRange`}
                      checked={filterParams?.enableDateRange}
                      onChange={(e) => handleFilterParamsChange(e)}
                    />
                  </div>
                  <Form.Group className="">
                    <Form.Label>Date Range</Form.Label>
                    <div className="position-relative">
                      <RsDateRangePicker
                        placement="topStart"
                        value={
                          filterParams.startDate && filterParams.endDate
                            ? [
                                parse(
                                  filterParams.startDate,
                                  "yyyy-MM-dd",
                                  new Date()
                                ),
                                parse(
                                  filterParams.endDate,
                                  "yyyy-MM-dd",
                                  new Date()
                                ),
                              ]
                            : []
                        }
                        onClean={() => clearDateRange()}
                        onOk={(date) => filterByDateRange(date)}
                      />
                    </div>
                  </Form.Group>
                </div>

                <div className="buttons rounded">
                  <Button onClick={() => reset()} variant="white">
                    Reset
                  </Button>
                  <Button onClick={() => search()} variant="primary">
                    Search
                  </Button>
                </div>
              </Form>
            </div>
          </div>
          <div className="content-body">
            <header>
              <div className="d-flex  ">
                {!showFilter && (
                  <button
                    onClick={() => setShowFilter(!showFilter)}
                    className="btn filter"
                  >
                    <FilterTwoIcon />
                  </button>
                )}
                <div>
                  <h6>
                    Company Target
                    <Button variant="" onClick={() => refetch()}>
                      <RefreshIcon />
                    </Button>
                  </h6>
                  <p>More information about your business target</p>
                </div>
              </div>
              <div
                className="actions"
                style={{
                  zIndex: "10",
                }}
              >
                <Button
                  onClick={() => {
                    setIsUpdate(false);
                    setShow(true);
                    setTarget({});
                  }}
                >
                  +Create
                </Button>
              </div>
            </header>
            <div className="px-md-4">
              <TableComponent
                responsive
                borderless
                striped
                tableHeadsFunction={tableHead}
                mainDataArray={data?.data || []}
                className="product-table text-nowrap"
                tableDataRowFunction={tableData}
                // tableRowClick={(e, el) => manageTransaction(e, el)}
              />

              {!isFetching && isSuccess && isEmpty(data?.data) ? (
                <NoTableItem queryParams={queryParams} />
              ) : null}
            </div>
            <div className="d-flex justify-content-between px-3 align-items-center pagination">
              {/*<p className="m-0">
                            Showing {data?.startIndex + 1} to{" "}
                            {data?.endIndex <= data?.count ? data?.endIndex : data?.count}{" "}
                            of {data.count} entries
                              </p> */}
              <div className="pagination_left">
                <p className="m-0 p-0">Show</p>
                <select
                  value={queryParams.limit}
                  name="limit"
                  className="form-select "
                  onChange={(e) => handleSearchQueryChange(e)}
                >
                  <option value="10">10 rows</option>
                  <option value="20">20 rows</option>
                  <option value="30">30 rows</option>
                  <option value="40">40 rows</option>
                  <option value="50">50 rows</option>
                  <option value="100">100 rows</option>{" "}
                </select>
              </div>

              <ReactPaginate
                {...paginationOptions}
                pageCount={Math.ceil(data?.count / queryParams.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={0}
                onPageChange={({ selected }) => {
                  document.body.scrollTop = document.documentElement.scrollTop = 0;
                  setQueryParams({
                    ...queryParams,
                    page: selected + 1,
                  });
                }}
                forcePage={queryParams.page - 1}
              />
            </div>
          </div>
        </div>
      </div>
      {show && (
        <TargetCreationModal
          show={show}
          setShow={setShow}
          refetch={refetch}
          isUpdate={isUpdate}
          target={target}
        />
      )}
      {view && (
        <TargetPerformanceModal
          show={view}
          setShow={setView}
          title={showDetails.title}
          id={showDetails.id}
        />
      )}
    </main>
  );
}
